/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiWebhookSigningKeyFromJSON(json) {
    return StreemApiWebhookSigningKeyFromJSONTyped(json, false);
}
export function StreemApiWebhookSigningKeyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sid': !exists(json, 'sid') ? undefined : json['sid'],
        'webhookSid': !exists(json, 'webhook_sid') ? undefined : json['webhook_sid'],
        'sharedSecret': !exists(json, 'shared_secret') ? undefined : json['shared_secret'],
        'expiresAt': !exists(json, 'expires_at') ? undefined : (new Date(json['expires_at'])),
        'label': !exists(json, 'label') ? undefined : json['label'],
    };
}
export function StreemApiWebhookSigningKeyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sid': value.sid,
        'webhook_sid': value.webhookSid,
        'shared_secret': value.sharedSecret,
        'expires_at': value.expiresAt === undefined ? undefined : (value.expiresAt.toISOString()),
        'label': value.label,
    };
}
//# sourceMappingURL=StreemApiWebhookSigningKey.js.map